

export function MergeArrayValues<T extends { [param: string]: any }>(
    existingArray: T[],
    newItems: T | T[],
    param: string = "id"
): T[] {
    // Ensure newItems is always an array
    const itemsToAdd = Array.isArray(newItems) ? newItems : [newItems];

    // Combine both arrays
    const combinedItems = [...existingArray, ...itemsToAdd];

    // Use a Map to keep track of unique objects by the value of `param`
    const uniqueMap = new Map<any, T>();
    for (const item of combinedItems) {
        // If we encounter the same key again, it will overwrite the previous
        // If you want to preserve the first occurrence, only set if not present
        uniqueMap.set(item[param], item);
    }

    // Return the objects from the Map
    return Array.from(uniqueMap.values());
}

export function MergeMultipleArrayValues<T extends Record<string, any>>(
    param: keyof T = "id",
    ...arrays: (T[] | T)[]
): T[] {
    const map = new Map<T[keyof T], T>();

    for (const arr of arrays) {
        const normalized = Array.isArray(arr) ? arr : [arr];

        for (const item of normalized) {
            map.set(item[param], item);
        }
    }

    return Array.from(map.values());
}